module.exports = __webpack_public_path__ + "img/Group4_26sp.e42915a3.jpg";